import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { serviceData } from "./ServiceData";
import Button from "../Button";

const ServiceDetail = ({ onOpenEstimate }) => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const service = serviceData[slug];

  if (!service) return <div className="p-8 text-center">Service not found</div>;

  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="flex items-center gap-4 mb-6">
        {service.icon}
        <h1 className="text-3xl font-bold text-green-800">{service.title}</h1>
      </div>

      <p className="text-gray-700 mb-6">{service.description}</p>

      <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-6">
        {service.points.map((point) => (
          <li key={point}>{point}</li>
        ))}
      </ul>

      <Button onClick={onOpenEstimate}>Get an Estimate</Button>

      <div className="mt-6">
        <button
          onClick={() => navigate(-1)}
          className="text-sm text-gray-600 hover:underline"
        >
          ← Back
        </button>
      </div>
    </div>
  );
};

export default ServiceDetail;
